/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Course_Content_Title_Default_VideoInputs */

const en_course_content_title_default_video = /** @type {(inputs: Course_Content_Title_Default_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video`)
};

const ja_course_content_title_default_video = /** @type {(inputs: Course_Content_Title_Default_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`動画`)
};

const fr_course_content_title_default_video = /** @type {(inputs: Course_Content_Title_Default_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vidéo`)
};

const de_course_content_title_default_video = /** @type {(inputs: Course_Content_Title_Default_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video`)
};

/**
* | output |
* | --- |
* | "Video" |
*
* @param {Course_Content_Title_Default_VideoInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const course_content_title_default_video = /** @type {((inputs?: Course_Content_Title_Default_VideoInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Course_Content_Title_Default_VideoInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_course_content_title_default_video(inputs)
	if (locale === "ja") return ja_course_content_title_default_video(inputs)
	if (locale === "fr") return fr_course_content_title_default_video(inputs)
	return de_course_content_title_default_video(inputs)
});